import React, { useRef } from 'react';
import { Descriptions, Modal } from 'antd';
import Button from 'app/components/Button';
import { RequirementFields } from 'app/pages/BookInspection/constants';
import { Block } from '../../../../Elements';
import get from 'lodash/get';
import Panel from 'app/components/Layout/Panel';
import classes from './Style.module.scss';
import Edit from './Edit';
import { Formik, useFormikContext } from 'formik';

const InspectionRequirement = (props: { value: any }) => {
  const formikRef = useRef(null);
  const { values: initialValues, setValues } = useFormikContext();
  const { value } = props;
  const [edit, setEdit] = React.useState(false);

  return (
    <Panel
      className={classes.inspectionRequirement}
      title="A) Inspection Requirement"
      extra={
        <Button
          type="link"
          onClick={() => {
            setEdit(true);
          }}
        >
          Edit
        </Button>
      }
    >
      <Block>
        <Descriptions
          column={{
            xl: 4,
            lg: 3,
            md: 2,
            sm: 1,
            xs: 1
          }}
        >
          {RequirementFields.map((item: any, index) => {
            return (
              <Descriptions.Item
                contentStyle={{ marginRight: 8 }}
                span={1}
                label={item.label}
                key={index}
              >
                {item.render(get(value, item.dataIndex), value)}
              </Descriptions.Item>
            );
          })}
        </Descriptions>
      </Block>
      <Modal
        open={edit}
        width="80vw"
        title="Inspection Requirement"
        cancelButtonProps={{ hidden: true }}
        onOk={() => {
          formikRef.current.submitForm();
          setEdit(false);
        }}
        onCancel={() => {
          setEdit(false);
        }}
        okText="Confirm"
      >
        <Formik
          initialValues={initialValues}
          enableReinitialize
          onSubmit={(values) => {
            setValues(values);
          }}
        >
          {(formikProps) => {
            formikRef.current = formikProps;
            return <Edit />;
          }}
        </Formik>
      </Modal>
    </Panel>
  );
};

export default InspectionRequirement;
